import { ReactNode } from 'react';

import { IAlertProps } from 'components/shared/Alert/types';

import { TDragProps } from '../EventList/types';
import { TimeFormat } from '../types';

export interface IEventOptionProps {
  id: number;
  icon: string;
  content: ReactNode;
  error?: EventOptionError;
  isDeletable?: boolean;
  isDraggable: boolean;
  dragProps: TDragProps;
}

export interface IEventActionMenuProps {
  onClick: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export enum ETransferTypes {
  Arrival = 'arrival',
  Departure = 'departure',
}

export type EventOptionError = Pick<IAlertProps, 'variant' | 'content' | 'className'>;

export type EventOptionConfig = {
  timeFormat?: TimeFormat;
  readonly?: boolean;
};
